module.exports = __webpack_public_path__ + "static/media/valu-logo.14249d36.png";